module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "agent-examine-dialog",
    attrs: {
      "title": _vm.title,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.visiable),
      callback: function($$v) {
        _vm.visiable = $$v
      },
      expression: "visiable"
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "examine-form",
    attrs: {
      "label-width": "84px",
      "model": _vm.examineData
    }
  }, [_c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "value": _vm.baseInfo,
      "isReadOnly": true,
      "isRequired": true,
      "isComShow": true
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "申请图片"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.RebateImgs), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "cut-line"
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核结果"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.examineData.RebateStatus),
      callback: function($$v) {
        _vm.$set(_vm.examineData, "RebateStatus", $$v)
      },
      expression: "examineData.RebateStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "审核通过",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审核未通过",
      "value": "1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examineData.RebateStatus == 2),
      expression: "examineData.RebateStatus==2"
    }],
    attrs: {
      "label": "选择升级区域(可多选)",
      "label-width": "110px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "data": _vm.AreaList,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProvName",
      "label": "省"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CityName",
      "label": "市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "区"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AreaName !== '') ? _c('span', [_vm._v(_vm._s(scope.row.AreaName))]) : _c('span', [_vm._v("--")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examineData.RebateStatus == 1),
      expression: "examineData.RebateStatus==1"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核意见"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.examineData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.examineData, "AuditRemark", $$v)
      },
      expression: "examineData.AuditRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0bf27dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/AgentAudit/components/examinDialog/index.vue
// module id = 1560
// module chunks = 1